module.exports = __webpack_public_path__ + "static/media/pep-circle-transfers.b35ed234.png";